import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const servicesApi = createApi({
    reducerPath: 'servicesApi',
    tagTypes: ['services'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getServices: build.query({
            query: ({queryOptions, ...params}) => ({
                url: api.services.getServices(),
                method: 'GET',
                params,
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, ...(queryArgs?.location_ids ?? [])]
            },
            merge: (currentCache, newItems, {arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            transformResponse: (response, meta, {queryOptions}) => {
                if (queryOptions?.flattenSubServices) {
                    return response.flatMap(service => [
                        service,
                        ...(service.additionalServices || []).map(additional => ({
                            ...additional,
                        }))
                    ]).filter(i => !i.selected);
                }
                return response.filter(i => !i.selected)
            },
            providesTags: ['services']
        }),
        createService: build.mutation({
            query: (data) => ({
                url: api.services.createService(),
                method: 'POST',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        servicesApi.util.updateQueryData('getServices', {location_ids: [patch.location_id]}, (draft) => {
                            draft.unshift(data)
                        })
                    )
                } catch (error) {
                    console.error('Failed to update cache:', error)
                }
            },
        }),
        editService: build.mutation({
            query: ({id, ...data}) => ({
                url: api.services.editService(id),
                method: 'PUT',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        servicesApi.util.updateQueryData('getServices',  {location_ids: [patch.location_id]} , (draft) => {
                            const itemIndex = draft?.findIndex(item => item.id === patch.id)
                            if (itemIndex !== -1) {
                                draft[itemIndex] = data
                            }
                        })
                    )
                } catch(e) {
                    console.error(e)
                }
            },
        }),
        deleteService: build.mutation({
            query: ({ id }) => ({
                url: api.services.deleteService(id),
                method: 'DELETE',
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(
                        servicesApi.util.updateQueryData('getServices', {location_ids: [patch.location_id]}, (draft) => {
                            const index = draft.findIndex((service) => service.id === patch.id);
                            if (index !== -1) {
                                draft.splice(index, 1)
                            } else {
                                console.warn('Service not found in cache')
                            }
                        })
                    );
                } catch (e) {
                    console.error('Delete failed:', e)
                }
            },
        }),
    })
})

export const { useDeleteServiceMutation, useEditServiceMutation } = servicesApi
